import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { useAuth } from '@clerk/clerk-react';

export const Route = createFileRoute('/org/$orgId/')({
  component: OrgPublicRedirect,
});

function OrgPublicRedirect() {
  const { orgId } = Route.useParams();
  const navigate = useNavigate();
  const { isSignedIn, isLoaded } = useAuth();

  useEffect(() => {
    if (!isLoaded) return;
    if (isSignedIn) {
      navigate({ to: '/org/$orgId/environments', params: { orgId }, replace: true });
    } else {
      navigate({ to: '/', replace: true });
    }
  }, [isLoaded, isSignedIn, navigate, orgId]);

  return null;
}


